module.exports = __webpack_public_path__ + "static/metasuggestions-c7b72aaecae9fa46b30c280e0b69ca95.png";